import Vue from 'vue'

const loading = {show, hide}

export {
  alert,
  loading
}

function alert (...args) {
  let n = args.length - 1
  let onHide = typeof args[n] === 'function' ? args[n--] : null
  let content = args[n--]
  let title = n >= 0 ? args[n] : ''
  Vue.$vux.alert.show({title, content, onHide})
}

function show (text) {
  Vue.$vux.loading.show({text})
}

function hide () {
  Vue.$vux.loading.hide()
}



// WEBPACK FOOTER //
// ./src/utils/dlg.js